import { render, staticRenderFns } from "./ActionsColumns.vue?vue&type=template&id=370a09ee&"
import script from "./ActionsColumns.vue?vue&type=script&lang=js&"
export * from "./ActionsColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports